import React from 'react';
import PropTypes from 'prop-types';

function AppPreview({ panels }) {
  const renderPanel = React.useCallback((item) => {
    if (item.type === 'WALLET') return <AppWallet key={item.id} />;
    if (item.type === 'MAIN_MODULE') return <AppMainModules key={item.id} />;
    if (item.type === 'SUB_MODULE') return <AppSubModules key={item.id} />;
    if (item.type === 'SLIDER')
      return <AppSlider key={item.id} label={item.label} />;
    if (item.type === 'SLIDER_SQUARE')
      return <AppSliderSquare key={item.id} label={item.label} />;
    return <div key={item.id}>{item.type}</div>;
  }, []);
  return (
    <div className="p-6">
      <div className="block text-sm font-medium text-gray-700 mb-1">
        Preview
      </div>
      <div className="aspect-w-7 aspect-h-15 rounded-3xl bg-gray-800 relative">
        <div className="absolute top-2 w-1/3 left-1/3 z-10 rounded-b-full bg-gray-800 h-2" />
        <div className="absolute inset-0 p-2 flex">
          <div className="bg-white rounded-2xl w-full space-y-3 p-3 overflow-y-auto">
            <AppHeader />
            {panels.map(renderPanel)}
          </div>
        </div>
      </div>
    </div>
  );
}

AppPreview.propTypes = {
  panels: PropTypes.instanceOf(Array).isRequired,
};

/* App Wallet */
function AppHeader() {
  return (
    <div className="px-2 pb-2 pt-4 text-center -m-2 border-b text-sm font-semibold tracking-wide text-gray-500">
      App Name
    </div>
  );
}
/* App Wallet End */

/* App Wallet */
function AppWallet() {
  return (
    <div className="bg-gray-100 rounded-lg h-8 w-full" />
    // <div className="pt-2">
    //   <div className="bg-gray-200 rounded-lg p-2 text-center text-gray-400">
    //     Wallet Here
    //   </div>
    // </div>
  );
}
/* App Wallet End */

/* App Main Modules */
function AppMainModules() {
  return (
    <div className="px-4">
      <div className="grid grid-cols-4 gap-2 border rounded-lg p-2">
        <div className="border bg-gray-50 border-dashed border-gray-300 rounded-full aspect-h-1 aspect-w-1" />
        <div className="border bg-gray-50 border-dashed border-gray-300 rounded-full aspect-h-1 aspect-w-1" />
        <div className="border bg-gray-50 border-dashed border-gray-300 rounded-full aspect-h-1 aspect-w-1" />
        <div className="border bg-gray-50 border-dashed border-gray-300 rounded-full aspect-h-1 aspect-w-1" />
      </div>
    </div>
  );
}
/* App Main Modules End */

/* App Sub Modules */
function AppSubModules() {
  return (
    <div className="grid grid-cols-4 gap-2">
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
      <div className="border bg-gray-50 border-dashed border-gray-300 rounded-xl aspect-h-1 aspect-w-1" />
    </div>
  );
}
/* App Sub Modules End */

/* App Slider */
function AppSlider({ label }) {
  return (
    <div>
      <div className="text-xs font-semibold tracking-wide text-gray-500 mb-2">
        {label}
      </div>
      <div className="space-x-2 overflow-x-auto no-scrollbar whitespace-nowrap">
        <div className="inline-block w-2/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-16 aspect-h-9" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
        <div className="inline-block w-2/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-16 aspect-h-9" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
        <div className="inline-block w-2/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-16 aspect-h-9" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
      </div>
    </div>
  );
}

AppSlider.propTypes = {
  label: PropTypes.string.isRequired,
};
/* App Slider End */

/* App Slider Square */
function AppSliderSquare({ label }) {
  return (
    <div>
      <div className="text-xs font-semibold tracking-wide text-gray-500 mb-2">
        {label}
      </div>
      <div className="space-x-2 overflow-x-auto no-scrollbar whitespace-nowrap">
        <div className="inline-block w-1/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-1 aspect-h-1" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
        <div className="inline-block w-1/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-1 aspect-h-1" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
        <div className="inline-block w-1/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-1 aspect-h-1" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
        <div className="inline-block w-1/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-1 aspect-h-1" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
        <div className="inline-block w-1/3 space-y-1">
          <div className="border bg-gray-50 border-dashed border-gray-300 rounded-lg aspect-w-1 aspect-h-1" />
          <div className="bg-gray-100 rounded-lg h-2 w-2/3" />
          <div className="bg-gray-100 rounded-lg h-2 w-1/3" />
        </div>
      </div>
    </div>
  );
}

AppSliderSquare.propTypes = {
  label: PropTypes.string.isRequired,
};
/* App Slider Square End */

export default AppPreview;
